import { render, staticRenderFns } from "./DormWidget.vue?vue&type=template&id=7314c3b2&scoped=true"
import script from "./DormWidget.vue?vue&type=script&lang=js"
export * from "./DormWidget.vue?vue&type=script&lang=js"
import style0 from "./DormWidget.vue?vue&type=style&index=0&id=7314c3b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.13_cache-loader@4.1.0_webpack@4.47.0__coffee-script@_ithsyumg4b75nafq24rv3fneqy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7314c3b2",
  null
  
)

export default component.exports